package io.janni.wedding.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.color.ColorVar
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Span
import io.janni.wedding.toSitePalette
import org.jetbrains.compose.web.css.px

val FooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(Color.rgba(255, 255, 255, 0.2f))
        .borderRadius(topLeft = 16.px, topRight = 16.px)
        .padding(topBottom = 1.5.cssRem, leftRight = 10.percent)
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(
        FooterStyle.toModifier()
            .backdropFilter(blur(20.px))
            .then(modifier),
        contentAlignment = Alignment.Center
    ) {
        Span(Modifier
            .opacity(100.percent)
            .textAlign(TextAlign.Center)
            .styleModifier {
                property("text-shadow", "2px 2px 4px rgba(0, 0, 0, 0.3), 0px 0px 8px rgba(0, 0, 0, 0.2)")
            }
            .toAttrs()
        ) {
            val sitePalette = ColorMode.current.toSitePalette()
            SpanText("Fotos von ")
            Link(
                "https://gknoll.de",
                "Guido Knoll",
                Modifier.setVariable(ColorVar, sitePalette.brand.primary),
                variant = UncoloredLinkVariant
            )
            SpanText(", Website erstellt von ")

            SpanText(
                "Jan-Niclas de Vries",
                Modifier.setVariable(ColorVar, sitePalette.brand.primary),
            )
        }
    }
}
